<template>
  <div class="row">
    <div class="col-md-8">
      <h3>Transactions from last 7 days</h3>
    </div>
    <div class="col-md-2 offset-md-2">
      <router-link :to="{ name: 'Add Transaction'}" style="float:right">
        <p-button type="primary" round>
          Add Transaction
        </p-button>
      </router-link>
    </div>
    
    <div class="col-md-6" id="transactionPieChart" v-if="loaded">
      <chart-card
        :chart-data="overallChart"
                  chart-type="Pie"
                  title="Overall Inflow/Outflow"
                  description="Overall Inflow/Outflow for last 7 days">
        <template slot="header">
          <h5 class="card-title">Overall</h5>
          <p class="card-category">Inflow/Outflow</p>
        </template>
      </chart-card>
    </div>
    
    <div class="col-md-6" v-if="loaded">
      <card>
        <template slot="header">
          <h4 class="card-title">Daily Entry</h4>
          <p class="card-category">Inflow/Outflow</p>
        </template>
        <bar-chart
          :labels="activityChart.labels"
          :height="250"
          :extra-options="activityChart.options"
          :datasets="activityChart.datasets">
        </bar-chart>
      </card>
    </div>

    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-sm-6">
              <el-select
                class="select-default"
                v-model="pagination.perPage"
                placeholder="Per page">
                <el-option
                  class="select-default"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </div>
            <div class="col-sm-6">
              <div class="pull-right">
                <fg-input class="input-sm"
                          placeholder="Search"
                          v-model="searchQuery"
                          addon-right-icon="nc-icon nc-zoom-split">
                </fg-input>
              </div>
            </div>
          </div>
          <div class="col-sm-12 mt-2">
            
            <div class="card" v-for="(data, index) in queriedData" :key="index">
              <div class="card-body" style="border-left: 6px solid" 
                :style="data.type_id == 1 ? 'border-color:#6bd098': 'border-color:#ef8157'">
                <div class="row">
                  <span class="small col">{{ '******' + data.account_number.slice(-4)}} {{data.bank_name}}</span>
                  <div style="width:100%">
                    
                    <span class="col-md-2 float-left">{{data.transaction_date}}</span>
                    <span class="col-md-3  offset-md-2 float-right"  
                      style="text-align:right">{{data.amount}}</span>
                  </div>
                </div>
                <div style="border-top: 1px #ebeef5 solid;line-height: 20px;">{{data.remark}}</div>
              </div>
            </div>
          </div>
          <div class="col-sm-6 pagination-info">
            <p class="category">Showing {{from + 1}} to {{to}} of {{total}} entries</p>
          </div>
          <div class="col-sm-6">
            <p-pagination class="pull-right"
                          v-model="pagination.currentPage"
                          :per-page="pagination.perPage"
                          :total="pagination.total">
            </p-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { Card } from 'src/components/UIComponents'
  import ChartCard from 'src/components/UIComponents/Cards/ChartCard'
  import LineChart from 'src/components/UIComponents/Charts/LineChart'
  import BarChart from 'src/components/UIComponents/Charts/BarChart'
  import PieChart from 'src/components/UIComponents/Charts/PieChart'

  import Vue from 'vue'
  import {Table, TableColumn, Select, Option} from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import sweetAlert from 'sweetalert2'
  import categories from 'src/categories'
  
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)

  const tooltipOptions = {
    tooltipFillColor: "rgba(0,0,0,0.5)",
    tooltipFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
    tooltipFontSize: 14,
    tooltipFontStyle: "normal",
    tooltipFontColor: "#fff",
    tooltipTitleFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
    tooltipTitleFontSize: 14,
    tooltipTitleFontStyle: "bold",
    tooltipTitleFontColor: "#fff",
    tooltipYPadding: 6,
    tooltipXPadding: 6,
    tooltipCaretSize: 8,
    tooltipCornerRadius: 6,
    tooltipXOffset: 10,
  };
  export default {
    components: {
      Card,
      ChartCard,
      LineChart,
      BarChart,
      PieChart,
      PPagination
    },
    watch: {
      tableData: function(){
        this.queriedData
      }
    },

    computed: {
      pagedData () {
        return this.tableData.slice(this.from, this.to)
      },
      /***
       * Searches through table data and returns a paginated array.
       * Note that this should not be used for table with a lot of data as it might be slow!
       * Do the search and the pagination on the server and display the data retrieved from server instead.
       * @returns {computed.pagedData}
       */
      queriedData () {
        if (!this.searchQuery) {
          this.pagination.total = this.tableData.length
          return this.pagedData
        }
        let result = this.tableData
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch) {
              let rowValue = row[key].toString()
              if (rowValue.includes && rowValue.includes(this.searchQuery)) {
                isIncluded = true
              }
            }
            return isIncluded
          })
        this.pagination.total = result.length
        return result.slice(this.from, this.to)
      },
      to () {
        let highBound = this.from + this.pagination.perPage
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      },
      from () {
        return this.pagination.perPage * (this.pagination.currentPage - 1)
      },
      total () {
        this.pagination.total = this.tableData.length
        return this.tableData.length
      }
    },
    data() {
      return {
        loaded: false,
        activityChart: {
          
          datasets: [
            {
              label: "Outflow",
              borderColor: '#fcc468',
              fill: true,
              backgroundColor: '#fcc468',
              hoverBorderColor: '#fcc468',
              borderWidth: 8,
              data: [],
            },
          ],
          options: {
            tooltips: tooltipOptions
          }
        },
        overallChart: {
          labels: ['Inflow', 'Outflow'],
          datasets: [{
            label: "Overall",
            pointRadius: 0,
            pointHoverRadius: 0,
            backgroundColor: [
              '#6bd098',
              '#ef8157'
            ],
            borderWidth: 0,
            data: []
          }],
          options: {
            tooltips: tooltipOptions,
            legend: {
              display: true
            }
          }
        },
        pagination: {
          perPage: 10,
          currentPage: 1,
          perPageOptions: [10, 25, 50],
          total: 0
        },
        searchQuery: '',
        propsToSearch: ['remark'],
        tableColumns: [
          {
            prop: 'transaction_date',
            label: 'Date',
            width: 10
          },
          {
            prop: 'remark',
            label: 'Transaction',
            minWidth: 250
          },
          {
            prop: 'name',
            label: 'Category'
          },
          {
            prop: "amount",
            label: 'Amount',
          }
        ],
        tableData: []
      }
    },
    methods: {
      notifyVue(theMessage) {
        this.$notify(
        {
          message: theMessage,   
        })
      },
      handleDelete (index, row) {
        this.$http.delete('/transactions/' + row.id)
        .then(response=>{
          if(response.data.created_at){
            
          }
          
          let indexToDelete = this.tableData.findIndex((tableRow) => tableRow.id === row.id)
          if (indexToDelete >= 0) {
            this.tableData.splice(indexToDelete, 1)
          }
          
        })
        .catch(error =>{
          //what to do when there is an error with the registration
          
        })
        
      },
      getTransactions () {
        this.$http.get ('/transactions')
        .then(response => {

          if(response.data.length == 0 ) {
            return
          }

          let transactionData = response.data
          let transactionLabelStart = []
          let totalType1 = 0  //type 1 transaction is income
          let totalType2 = 0  //type 2 transaction is expense

          for (let key = 0; key < transactionData.length; key++) {
              
            if(!transactionLabelStart.includes(transactionData[key]['name'])) {

              transactionLabelStart.push(transactionData[key]['name'])

            }

            if(transactionData[key]['type_id'] == 1) {
              totalType1 = totalType1 + transactionData[key]['amount']
            }

            if(transactionData[key]['type_id'] == 2) {
              totalType2 = totalType2 + transactionData[key]['amount']
            }

          }

          this.overallChart.datasets[0]['data'] = [totalType1, totalType2]
          this.activityChart.labels = transactionLabelStart
          this.loaded = true

          response.data.map(function (e) {
            e.amount = new Intl.NumberFormat('en-US', 
                { style: 'currency', currency: 'NGN' }).format(e.amount / 100).replace('NGN', '₦')
            
            e.transaction_date = e.transaction_date.substring(0, 10)
            e.bank_name = e.bank_name.replace('First City Monument Bank', 'FCMB')
            e.bank_name = e.bank_name.replace('Guaranty Trust Bank', 'GTB')
            e.bank_name = e.bank_name.replace('VFD Microfinance Bank Limited', 'VFD')
           
            e.bank_name = e.bank_name.replace('United Bank For Africa', 'UBA')
            e.bank_name = e.bank_name.replace('Microfinance Bank', 'MFB')

            if (e.bank_name.substring(e.bank_name.length - 5) == ' Bank') {
              e.bank_name= e.bank_name.replace(' Bank', '')
            }
          });

          this.tableData = response.data
          
        })
        .catch(err => console.error(err))
      },

      async getRecentTransactions () {
        await this.$http.get ('/transactions/recent')
        .then(response =>{

          let tL = this.tableData.length
          let recentTransaction = response.data

          for (let x = 0; x < recentTransaction.length; x++) {
            recentTransaction[x]['amount'] = new Intl.NumberFormat('en-US', 
              { style: 'currency', currency: 'NGN' }).format(recentTransaction[x]['amount'] / 100).replace('NGN', '₦')
            
            recentTransaction[x]['transaction_date'] = recentTransaction[x]['transaction_date'].substring(0, 10)

            let y = tL + x

            this.tableData[y] = response.data[x] 
          }

        })
        .catch(error => {
          console.log(error)
          if (error.response.status == 500) {
            this.notifyVue('Whoops. Something Went Wrong')
          }
          if (error.response.status == 404) {
            this.notifyVue('Whoops. Your request is missing')
          }
        })
      }
    },
    async mounted () {
      this.getTransactions ()
      this.getRecentTransactions ()

    }
  }
</script>
<style lang="scss">
  .el-table .td-actions {
    button.btn {
      margin-right: 5px;
    }
  }
  .small { color: #9A9A9A !important; }
  #transactionPieChart .card-footer {
    display: none
  }
</style>
